import React from 'react';
import { IOldIconProps } from './type';

const directionRotation = {
  right: 0,
  left: 180,
  bottom: 90,
  top: -90,
};

interface IArrowIconProps extends IOldIconProps {
  headDirection: 'right' | 'left' | 'bottom' | 'top';
  rotate?: number;
}

const Arrow: React.FC<IArrowIconProps> = ({
  width = 8,
  height = 14,
  color = '#000',
  rotate = 0,
  headDirection,
  ...props
}) => {
  const rotation = rotate || directionRotation[headDirection] || 0;

  return (
    <svg
      {...props}
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 8 14`}
      style={{
        transform: `translateY(1px) rotate(${rotation}deg)`,
        transition: 'transform 0.5s',
      }}
    >
      <path
        id="Path"
        d="M0,12.349,4.947,7,0,1.651,1.527,0,8,7,1.527,14Z"
        fill={color}
      />
    </svg>
  );
};

export default Arrow;
